import energyLightIcon from '@/assets/icons/energy-light.svg'
import quizIcon from '@/assets/icons/quiz.png'

import { EnergyIcon, HeaderTitle, HeaderWrapper, QuizIcon, RewardCount, RewardRow } from './styles'

export default function QuizHeader() {
  return (
    <HeaderWrapper>
      <QuizIcon
        src={quizIcon}
        alt='quiz'
      />
      <HeaderTitle>퀴즈 풀면</HeaderTitle>
      <RewardRow>
        <RewardCount>1</RewardCount>
        <EnergyIcon
          src={energyLightIcon}
          alt='energy'
        />
      </RewardRow>
    </HeaderWrapper>
  )
}
